<template>
  <div
    :id="authorHtmlId"
  >
    <user
      :userId="authorId"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'

import User from '@/components/User'

export default {
  components: {
    'user': User
  },

  computed: mapState({
    base: state => state.base,
    authorHtmlId () {
      return `author-${this.authorId}`
    }
  }),

  props: {
    authorId: {
      type: [ Number, String ],
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Author.vue